import React from 'react';
import { Typography, Button } from '@hpstellar/core/visId';

import './empty-cart-message.less';

export default ({
    title = 'None is the loneliest number',
    subtitle = 'Find some stuff to keep your cart company.',
    buttonProps = { children: 'Shop now', to: '/us-en/shop' },
}) => (
    <div className="empty-cart-message">
        <Typography className="empty-cart-message-title" variant="h3" tag="h4">
            {title}
        </Typography>
        <Typography variant="h4" tag="h5">
            {subtitle}
        </Typography>
        <Button className="shop-cta" size="small" {...buttonProps} />
    </div>
);
